import { useQuery } from '@tanstack/react-query';
import { GET } from '../services/index';

/**
 * บริษัททั้งหมดที่ user คนนี้เข้าถึงได้ (บริษัทหลัก + ที่ถูกเพิ่มเข้ามา)
 *
 * ตัวตนอ่านจาก JWT ฝั่ง backend ไม่ได้ส่ง id มาจาก frontend
 * → เปลี่ยน companyId ของแท็บก็ยังได้รายการเดิม จึงแคชได้ยาว ๆ
 */
export const useMyCompanies = (options = {}) =>
  useQuery(
    ['myCompanies'],
    async () => {
      const { result } = await GET('/api/v1/users/my-companies');
      return result || [];
    },
    {
      staleTime: 5 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
      refetchOnWindowFocus: false,
      ...options,
    },
  );
